import axios, {parseResponseData} from '@/axiosInstance.ts'
import {ReferringSpecialist} from '@/features/referring-specialists/types'
import {PaginationResponse, PaginationParams} from '@/types'
import {captureException} from '@sentry/react'
import {z} from 'zod'

// get specialists
export interface HttpGetSpecialistsOptions {
    params: PaginationParams & {
        search?: string
    }
}

const HttpGetSpelicialistsResponse = z.object({
    data: z.array(ReferringSpecialist),
    meta: PaginationResponse
})
export type HttpGetSpelicialistsResponse = z.infer<typeof HttpGetSpelicialistsResponse>

export const httpGetSpecialists = async ({params}: HttpGetSpecialistsOptions) => {
    const response = await axios.get('specialists', {params})
    return parseResponseData({
        responseData: response.data,
        onZodError: captureException,
        responseShape: HttpGetSpelicialistsResponse
    })
}

// get specialist
export interface HttpGetSpecialistOptions {
    urlParams: {
        id: string
    }
}

export const httpGetSpecialist = async ({urlParams}: HttpGetSpecialistOptions) => {
    const response = await axios.get(`specialists/${urlParams.id}`)
    return parseResponseData({
        responseData: response.data,
        onZodError: captureException,
        responseShape: ReferringSpecialist
    })
}
